
/// 处理fundus的fileData函数
function findColorById (id) {
  let color = ''
  let text = ''
  let rgba = ''
  if (id === 1) {
    color = '#00FFF0'
    rgba = 'rgba(0,255,240,0)'
    text = 'microaneurysms'
  } else if (id === 2) {
    color = '#FF00B8'
    rgba = 'rgba(255,0,184,0)'
    text = 'intraretinal hemorrhage'
  } else if (id === 3) {
    color = '#0094FF'
    rgba = 'rgba(0,148,255,0)'
    text = 'venous beading'
  } else if (id === 4) {
    color = '#03FF4A'
    rgba = 'rgba(3,255,74,0)'
    text = 'intraretinal microvascular abnormality'
  } else if (id === 5) {
    color = '#FFAAF1'
    rgba = 'rgba(255,170,241,0)'
    text = 'neovascularization'
  } else if (id === 6) {
    color = '#AC79FF'
    rgba = 'rgba(172,121,255,0)'
    text = 'vitreous hemorrhage'
  } else if (id === 7) {
    color = '#FF4A4A'
    rgba = 'rgba(255,74,74,0)'
    text = 'preretinal hemorrhage'
  } else if (id === 8) {
    color = '#FFC700'
    rgba = 'rgba(255,199,0,0)'
    text = 'preretinal hemorrhage'
  } else if (id === 9) {
    color = '#FFF859'
    rgba = 'rgba(255,248,89,0)'
    text = 'preretinal hemorrhage'
  } else if (id === 10) {
    color = '#FFFFFF'
    rgba = 'rgba(255,255,255,0)'
    text = 'preretinal hemorrhage'
  }
  const obj = {
    color: color,
    text: text,
    rgba: rgba
  }
  return obj
}

export function getTxtData (res) {
  // res  传入的字符串，只包含绘图数据
  // const arr = [1, 2, 3, 4, 5, 6, 7]/// 绘图的病症代号
  let data = []
  if (res.includes('\r\n')) {
    data = res.split('\r\n')
  } else if (res.includes('\n')) {
    data = res.split('\n')
  }

  const list = []
  data.forEach((item, index) => { ///
    const li = String(item).split('  ')
    // console.log('Number(li[3])', Number(li[3]))
    // console.log('li', li)
    const lii = li[0].split(' ')
    const re = findColorById(Number(lii[0]))
    if (li[1]) { // 不是approve
      const zuobiao = li[1].split('  ')
      const style = li[2] ? JSON.parse(li[2]) : undefined
      let direction = 0
      if (Array.isArray(style)) {
        direction = Number(li[3])
      } else {
        direction = Number(style)
      }
      const obj = {
        uuid: Number(new Date().getTime()), /// /只作为本地使用，不用存到文档中，所以此处读取时自动生成
        id: Number(lii[0]),
        x: Number(lii[1]),
        y: Number(lii[2]),
        w: Number(lii[3]),
        h: Number(lii[4]),
        doctor: String(zuobiao[0]).includes('AI') ? '' : zuobiao[0],
        color: re.color,
        text: re.text,
        originWidth: 0,
        originHeight: 0,
        direction: direction || 0
      }
      list.push(obj)
    }
  })

  const resd = {
    list: list
  }
  return resd
}

// 計算txt中的cx,cy,cw,ch
export function computedDataFundus (item, flag, styleList) {
  if (flag === 0) { /// 計算上傳坐標數據
    // 計算中心點坐標和寬高
    const x0 = ((item.x + item.w / 2) / (styleList.width / styleList.imgWidth_T)).toFixed(6)// 法二
    const y0 = ((item.y + item.h / 2) / (styleList.height / styleList.imgHeight_T)).toFixed(6)// 法二
    // 計算除以真實圖片寬高後的中心點坐標和w,h
    const x2 = Number((x0 / styleList.imgWidth_T).toFixed(6))
    const y2 = Number((y0 / styleList.imgHeight_T).toFixed(6))
    const w2 = Number((Math.abs(item.w) / styleList.width).toFixed(6))// 法二
    const h2 = Number((Math.abs(item.h) / styleList.height).toFixed(6))// 法二

    return { uuid: item.uuid, id: item.id, x: x2, y: y2, w: w2, h: h2, color: item.color, text: item.text, doctor: item.doctor, originWidth: item.originWidth, originHeight: item.originHeight, direction: item.direction }
    // return { id: item.id, x: x2, y: y2, w: w2, h: h2, doctor: item.doctor }
  } else { /// 計算顯示的坐標數據
    const iemw = 1
    const iemh = 1
    /// ****************图片按等比例展示后，不需要计算了
    // if (item.originWidth !== 0) {
    //   if (item.originWidth && item.originWidth >= styleList.width) {
    //     iemw = Number((item.originWidth / styleList.width).toFixed(6))
    //     iemh = Number((item.originHeight / styleList.height).toFixed(6))
    //   } else if (item.originWidth) {
    //     iemw = Number((styleList.width / item.originWidth).toFixed(6))
    //     iemh = Number((styleList.height / item.originHeight).toFixed(6))
    //   }
    // }

    // console.log('iemw', iemw, item.originWidth, styleList.width)
    // console.log('iemh', iemh, item.originHeight, styleList.height)

    /// 計算中心坐標和寬高
    const x0 = Number((item.x * styleList.imgWidth_T * (styleList.width / styleList.imgWidth_T)).toFixed(6))
    const y0 = Number((item.y * styleList.imgHeight_T * (styleList.height / styleList.imgHeight_T)).toFixed(6))
    const w = Number((item.w * styleList.width / iemw).toFixed(0))
    const h = Number((item.h * styleList.height / iemh).toFixed(0))
    const x = Number(((x0 - w / 2) / iemw).toFixed(0))
    const y = Number(((y0 - h / 2) / iemh).toFixed(0))
    return { uuid: item.uuid, id: item.id, x: x, y: y, w: w, h: h, color: item.color, text: item.text, doctor: item.doctor, originWidth: item.originWidth, originHeight: item.originHeight, direction: item.direction }
  }
}
